import {icon} from '@fortawesome/fontawesome-svg-core';
import {faShoppingCart, faStore} from '@fortawesome/free-solid-svg-icons';
export const icons = {
	shoppingCart: icon(faShoppingCart)?.html,
	store: icon(faStore)?.html,
};
